export default __webpack_public_path__ + "static/media/IMG_9931.e5c20181.jpg";